// extracted by mini-css-extract-plugin
export var container = "_nm-0";
export var dotAnimation = "_nm-2";
export var dotsLoading = "_nm-1";